// Imports
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router-dom';
import { HasPermission } from '../../core/security';
import { History } from './views';


const routerIncidents = () => {
    const user = useSelector(state => state.securityRedux.user);
    return (
        <Routes>
            {
                HasPermission(user, ["incdnt"], [265]) &&
                <Fragment>
                    <Route path='/' element={<Navigate to="/app/incidents/history" />}></Route>
                    <Route path='history' element={<History />} />
                </Fragment>
            }
            <Route path="*" element={<Navigate to="/app/error" />} />
        </Routes>
    );
};

export default routerIncidents
